<script>
import { ref } from 'vue';

export default {
  props: {
    isVisible: { type: Boolean },
    markers: { type: Array },
    colors: { type: Object },
  },
  emits: ['hoverLabel'],
  setup(props, { emit }) {
    const hoveredMarker = ref(null);

    function onMouseEnter(marker) {
      hoveredMarker.value = marker;
      emit('hoverLabel', marker);
    }

    function onMouseLeave() {
      hoveredMarker.value = null;
      emit('hoverLabel', null);
    }

    return {
      hoveredMarker,
      onMouseEnter,
      onMouseLeave,
    };
  },
};
</script>

<template>
  <Transition name="slide-fade">
    <div v-if="isVisible" class="legend-container">
      <div
        v-for="(marker, index) in markers"
        :key="index"
        class="legend-item"
        :class="{ dimmed: hoveredMarker && hoveredMarker !== marker }"
        @mouseenter="onMouseEnter(marker)"
        @mouseleave="onMouseLeave"
      >
        <div
          class="legend-stroke"
          :style="{ background: colors[marker] }"
        />
        <h6 class="legend-text">
          {{ marker }}
        </h6>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.legend-container {
  pointer-events: none;
  position: absolute;
  bottom: 15px;
  left: 45px;
  right: 38px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  box-sizing: border-box;
}

.legend-item {
  pointer-events: auto;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
  user-select: none;
  opacity: 1;
}

.legend-item:hover {
  transform: scale(1.05);
}

.legend-item.dimmed {
  opacity: 0.35;
}

.legend-text {
  font-weight: 400;
  text-align: left;
  margin: 0;
  color: white;
}

.legend-stroke {
  width: 30px;
  height: 3px;
  border-radius: 20px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(5px);
  opacity: 0;
}
</style>
